import { render, staticRenderFns } from "./ServiceProviderList.vue?vue&type=template&id=2d63cba0&"
import script from "./ServiceProviderList.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports